/* External dependencies */
import { ApolloClient, ApolloLink, InMemoryCache, NormalizedCacheObject } from '@apollo/client';
import { createHttpLink } from '@apollo/client/core';
import { AUTH_TYPE, createAuthLink } from 'aws-appsync-auth-link';
import { createSubscriptionHandshakeLink } from 'aws-appsync-subscription-link';
import { v4 as uuidv4 } from 'uuid';
import { fetchAuthSession } from 'aws-amplify/auth';
import * as AWS from 'aws-sdk';

export let anonymousClient: ApolloClient<NormalizedCacheObject>;
export let authenticatedClient: ApolloClient<NormalizedCacheObject>;

const variables = {
  region: 'us-west-2',
  identityPoolId: 'us-west-2:bef27d80-b3fd-4bb5-b586-97238d37f96e',
  apiKey: 'da2-g7o4lmvsq5enjph6osltewfl5u',
  userPoolId: 'us-west-2_Vks7GkhlO',
  userPoolClientId: '7nm1627efll9vkbn9dnqhimp4g',
  appsyncEndpoint: 'https://fsi7a2bd4ze6dpk53fzyfcvinu.appsync-api.us-west-2.amazonaws.com/graphql',
  appsyncSubscriptionEndpoint: 'wss://fsi7a2bd4ze6dpk53fzyfcvinu.appsync-realtime-api.us-west-2.amazonaws.com/graphql',
}

console.log('Variables: ', variables);

export async function setAnonymousClient(): Promise<ApolloClient<NormalizedCacheObject>> {
  if (anonymousClient) {
    return anonymousClient;
  }

  const anonymousClientConfig = {
    url: variables.appsyncEndpoint,
    region: variables.region,
    auth: {
      type: AUTH_TYPE.API_KEY as AUTH_TYPE.API_KEY,
      apiKey: variables.apiKey,
    },
    offlineConfig: {
      keyPrefix: `client-instance-${uuidv4()}`,
    },
  };
  console.log('anonymousClientConfig', anonymousClientConfig);
  const { url } = anonymousClientConfig;
  const httpLink = createHttpLink({ uri: url });

  const link = ApolloLink.from([
    createAuthLink(anonymousClientConfig),
    createSubscriptionHandshakeLink(anonymousClientConfig, httpLink),
  ]);

  const cache = new InMemoryCache();

  return (anonymousClient = new ApolloClient({
    link,
    cache,
  }));
}

export async function setAuthenticatedClient(): Promise<ApolloClient<NormalizedCacheObject>> {
  if (authenticatedClient) {
    return authenticatedClient;
  }
  console.log('Setting authenticated client...');

  AWS.config.update({ region: variables.region });
  try {
    const { credentials } = await fetchAuthSession();
    
    if (!credentials) {
      console.error('No credentials found in auth session');
      throw new Error('Authentication failed: No credentials available');
    }
    
    console.log('Credentials from authenticatedClient: ', credentials);
    
    const authenticatedClientConfig = {
      url: variables.appsyncEndpoint,
      region: variables.region,
      auth: {
        type: AUTH_TYPE.AWS_IAM as AUTH_TYPE.AWS_IAM,
        credentials,
      },
      offlineConfig: {
        keyPrefix: `client-instance-${uuidv4()}`,
      },
    };
    console.log('AuthenticatedClientConfig: ', authenticatedClientConfig);
    const httpLink = createHttpLink({ uri: authenticatedClientConfig.url });

    const link = ApolloLink.from([
      createAuthLink(authenticatedClientConfig),
      createSubscriptionHandshakeLink(authenticatedClientConfig, httpLink),
    ]);

    const cache = new InMemoryCache();

    return (authenticatedClient = new ApolloClient({
      link,
      cache,
    }));
  } catch (error) {
    console.error('Error setting up authenticated client:', error);
    return setAnonymousClient();
  }
}
